import { render, staticRenderFns } from "./_productAttribute.vue?vue&type=template&id=3f18f0f1&scoped=true&"
import script from "./_productAttribute.vue?vue&type=script&lang=js&"
export * from "./_productAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18f0f1",
  null
  
)

export default component.exports